import { fetchTokenAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { domainToRegex } from "../urlPatternConversion";
import logo from "./logo.svg";

export const amazonSellerCentral = defineConnector({
  identifier: "amazonSellerCentral",
  name: "Amazon Seller Central",
  tagLine: "Amazon marketplace management",
  logo,
  protocol: "http",
  tags: ["productivity", "data"],
  auth: (app) =>
    fetchTokenAuth({
      request: {
        url: "https://api.amazon.com/auth/o2/token",
        jsonBody: {
          grant_type: "refresh_token",
          refresh_token: app.secret.refreshToken,
          client_id: app.config.clientId,
          client_secret: app.secret.clientSecret,
        },
      },
      extract: { from: "jsonPath", paths: ["access_token"] },
      apply: {
        kind: "header",
        name: "x-amz-access-token",
        extraHeaders: [{ name: "user-agent", value: "3B/1.0" }],
      },
    }),
  steps: [
    {
      title: "Create a Selling Partner API application",
      items: [
        {
          kind: "markdown",
          content:
            "Create or reuse a Selling Partner API app in Seller Central, then copy the Login with Amazon client ID and client secret. You’ll also need a refresh token for the seller account you want to access.",
        },
      ],
    },
    {
      title: "Enter your Selling Partner API details",
      items: [
        {
          kind: "input",
          label: "SP-API host",
          required: true,
          defaultValue: "sellingpartnerapi-na.amazon.com",
          helperText:
            "Use the regional host that matches the account you are connecting, such as sellingpartnerapi-na.amazon.com, sellingpartnerapi-eu.amazon.com, or sellingpartnerapi-fe.amazon.com.",
          target: { kind: "configuration", field: "apiHost" },
        },
        {
          kind: "input",
          label: "LWA client ID",
          required: true,
          target: { kind: "configuration", field: "clientId" },
        },
        {
          kind: "input",
          label: "LWA client secret",
          required: true,
          target: { kind: "secrets", field: "clientSecret" },
        },
        {
          kind: "input",
          label: "Refresh token",
          required: true,
          target: { kind: "secrets", field: "refreshToken" },
        },
      ],
    },
  ],
  defaultUrlPattern: ({ apiHost }) => domainToRegex(apiHost),
  connectionTest: {
    protocol: "http",
    request: ({ apiHost }) => ({
      url: `https://${apiHost}/sellers/v1/marketplaceParticipations`,
      expectedStatus: [200, 403],
    }),
  },
});
